export default "__VITE_ASSET__5X8sWR7L__"